import { NavLinks } from 'src/layouts/NavigtaionLinkBuilder';

export interface LayoutStateInterface {
  hideMobileToolbar: boolean;
  navLinks: Array<NavLinks>;
}

function state(): LayoutStateInterface {
  return {
    hideMobileToolbar: false,
    navLinks: []
  }
}

export default state;
